import React from 'react'
import PropTypes from 'prop-types'
import * as Icons from '../icons'
import { Translation } from '@morningtrain/react-translations'
import { ValueToCollection, ValueToModel, WhenModelValue } from '@morningtrain/react-resources'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import SpecialDaysSmartview from 'widgets/smartviews/shifts/SpecialDaysSmartview'
import * as Displays from 'support/displays'
import CreateSpecialDaySmartview from 'widgets/smartviews/shifts/CreateSpecialDaySmartview'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import Text from '../formatting/Text'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

function CalendarItem ({
  children,
  onClick,
  date,
  currentMonth,
  currentYear
}) {
  const classNames = [
    'calendar-item',
    'relative',
    'border-r',
    'border-b',
    'border-gray-200',
    'p-2',
    'lg:p-4',
    currentMonth !== date.month() ? 'bg-highlight-300 cursor-default calendar-item--disabled' : 'bg-white cursor-pointer hover:bg-primary-500'
  ]

  return (
    <ValueToModel name={date.format('Y-MM-DD')}>
      <MountSmartviewWithModelOnClick smartview={<SpecialDaysSmartview date={date}/>} replace>
        <div onClick={onClick} className={classNames.join(' ')}>
          <div className='text-gray-400 text-sm font-medium'>{date.format('DD')}</div>
          <div className='text-xs truncate mt-2 lg:mt-3'>
            <ValueToCollection name='special_days'>
              {children}
            </ValueToCollection>
          </div>
          <WhenModelValue name='weather.temperature'>
            <div className='absolute top-4 right-2 flex items-center space-x-2'>
              <Text size='xs'>
                <Displays.Number name='weather.temperature' maxDecimals={0} minDecimals={0}/>°C
                / <Displays.Number
                name='weather.precipitation' maxDecimals={0}
                minDecimals={0}
              /> mm
              </Text>
              <div className='w-5 lg:w-6 lg:top-4 lg:right-4'>
                <Displays.Image name='weather.symbol_url'/>
              </div>
            </div>
          </WhenModelValue>
          <Can permission={Permissions.OPERATIONS_SPECIALDAYS_MANAGE}>
            <MountSmartviewOnClick smartview={<CreateSpecialDaySmartview date={date}/>} replace={false}>
              <div className='add-text flex items-center text-xs whitespace-no-wrap mt-2 lg:mt-4'>
                <Icons.PlusCircle className='w-4 h-4 mr-1'/>
                <Translation name='special_days.add'/>
              </div>
            </MountSmartviewOnClick>
          </Can>
          {/* <div className={'absolute top-4 right-4'}>
                        <Displays.Image name={[date.format('Y-MM-DD'), 'weather', 'symbol_url'].join('.')}/>
                    </div> */}
        </div>
      </MountSmartviewWithModelOnClick>
    </ValueToModel>
  )
}

CalendarItem.propTypes = {
  /**
   * onClick passed to div
   */
  onClick: PropTypes.func,
  /**
   * Date to be displayed on the calendar day
   */
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
   * Title to be displayed on the calendar day
   */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
   * Text to be display in the "add" button
   */
  addText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
   * Weather component
   */
  weather: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
   * "Disable" day to be used for days not in this week
   */
  disabled: PropTypes.bool
}

export default CalendarItem
